import { ReactNode } from 'react';

import { ChakraProvider, SystemContext } from '@chakra-ui/react';

import { raspberrySsrTheme } from '@nocowanie/common-ui/theme/raspberry-theme';

export const ThemeProvider = ({
    theme,
    children,
}: {
    theme?: SystemContext;
    children: ReactNode;
}): ReactNode => {
    return <ChakraProvider value={theme ?? raspberrySsrTheme}>{children}</ChakraProvider>;
};
